import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { width: "100%" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.openImport,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openImport) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[2] || (_cache[2] = _createElementVNode("p", null, "Import terminé", -1)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _ctx.closeReport
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { id: "print" }, {
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_2, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, "Numéro de lot:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.batchId), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Date, heure:", -1)),
                    _createElementVNode("td", null, _toDisplayString(new Date()), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Pocket du chauffeur:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.driverLicence), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Vignette du véhicule:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.vehiclePlate.vignette_id), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Nombre de coupons:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.processedCount), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "Numéro du scanner:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.currentScanner.label), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "Total $:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.totalAmount) + " $", 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "success darken-1",
                onClick: _ctx.printReceipt
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Imprimer ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "warning darken-1",
                onClick: _ctx.closeReport
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Annuler ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}